module.exports = __webpack_public_path__ + "img/9788983923851.fd282ab8.jpg";